export class Page {
   CreatedDate: Date;
   Title: string;
   Text: string;
   HeaderImagePath: string;
}